import Flatten from '@flatten-js/core';
import { GeometryUtils } from '../utils/Geometry.js';
export { Barrier };
class Barrier {
    constructor({ points, normal }) {
        this.points = points;
        this.normal = normal;
        const bb = GeometryUtils.boundingBox(this.points);
        this.minX = bb.minX;
        this.maxX = bb.maxX;
        this.minY = bb.minY;
        this.maxY = bb.maxY;
    }
    getSegment() {
        return new Flatten.Segment(new Flatten.Point(this.points[0][0], this.points[0][1]), new Flatten.Point(this.points[1][0], this.points[1][1]));
    }
}
//# sourceMappingURL=Barrier.js.map